import ReconciliationStepTemplate from './ReconciliationStepTemplate.vue';
export default {
    props: {
        previousStep: {
            type: [Boolean, String],
            required: false,
            default: false,
        },
        nextStep: {
            type: [Boolean, String],
            required: false,
            default: false,
        },
        csv: {
            type: Array,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
        // idImport: {
        //     type: Number,
        //     required: true
        // }
    },
    computed: {
        idImport() {
            return this.$route.params.importid;
        },
    },
    methods: {
        checkPreviousSteps() {
            if (this.value.template.date.columns.length == 0) {
                this.$emit('update-import-id', this.$route.params.importid);
                this.$emit('next', 'bankreconciliation-step2');
            }
        },
        checkMinColumns(key, min) {
            if (
                this.value.template[key].columns.length > 0 &&
                this.value.template[key].columns.length <= min
            ) {
                return true;
            } else {
                Push.error(this.$l10n.__('Vous devez sélectionner au minimum 1 colonne'), false);
            }
        },
        checkLabelColumns() {
            // check on previous template if label use columns no longer exists
            const nbColumns = this.csv.lastItem.length;
            this.value.template.label.columns = this.value.template.label.columns.filter(
                (column) => column < nbColumns,
            );
        },
    },
    components: {
        ReconciliationStepTemplate,
    },
};
